module.exports = __webpack_public_path__ + "img/indoor3.2b58ac1b.jpg";